export default /* glsl */`
    if (a < 0.01) discard;
`;
